import { useState, useEffect } from "react";
import "./blog.scss";
import { NavLink } from "react-router-dom";

const Blog = ({ title = true, dis = true, link = "/", data }) => {
  return (
    <div className="container-item3 mx-auto">
      <div className="item text-center pb-2 pt-3 mx-2">
        <div className="position-relative item-img">
          <img
            src={"http://marketgroup.tatdemo.ir/" + data.image}
            className="img"
            width="80%"
            height={221}
            alt
          />
          <div className="position-absolute img-gradient" />
        </div>
        <div className="bg-white mx-3 text-start pt-2 text my-3">
          {title && (
            <p className="mx-3" style={{ fontSize: 17, fontWeight: 600 }}>
              {data.title}
            </p>
          )}
          {dis && (
            <div className="main-text mx-3">
              <p className="text-color" style={{ fontSize: 13 }}>
                {data.description}
              </p>
            </div>
          )}
          <NavLink
            className="text-danger text-decoration-none mx-3"
            to={`/article/${data.id}`}
          >
            ادامه مطلب &gt;&gt;
          </NavLink>
          <hr className="text-secondary" />
          <div className="d-flex flex-row justify-content-between mx-3">
            <div>
              <p>{data.date}</p>
            </div>
            <div>
              <p>{data.writer}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
